
import React from 'react';
import { Spin, Tree, message,Select } from 'antd';
import MyAutoComplete  from './MyAutoComplete';
import  Tools  from '../../../tools/Tools';
import "./index.scss"
const TreeNode = Tree.TreeNode;
export default class SimpleTreeNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      userData: null,
      organizationId: this.props.organizationId ? this.props.organizationId : this.props.hasDefaultOrg?localStorage.getItem('accountId'):"",
      expandedKeys: [this.props.organizationId ? String(this.props.organizationId) : localStorage.getItem('accountId')],
      defaultSelectedKeys:this.props.hasDefaultOrg? [this.props.organizationId ? String(this.props.organizationId) : localStorage.getItem('accountId')]:[],
      autoExpandParent: false,
      selectedKeys:this.props.hasDefaultOrg? [this.props.organizationId ? String(this.props.organizationId) : localStorage.getItem('accountId')]:[],
      showTree: false,
      searchUrl: '/rest/account/brief/list?length=5&content=',
      platform: localStorage.getItem('platform'),
      treeVisible: false,
      width: '90%',
      popVisible: false,
      parentClass: this.props.parentClass,
      showRootName: this.props.showRootName,
      showSearchInput: true,
      type:this.props.type,
      accountName:this.props.accountName ? this.props.accountName : this.props.hasDefaultOrg?localStorage.getItem('accountName'):"",
    };
    this.onSelect = this.onSelect.bind(this);
    this.onExpand = this.onExpand.bind(this);
    this.getNodeTitle = this.getNodeTitle.bind(this);
    this.loadCustomerTree = this.loadCustomerTree.bind(this);
    this.loadCustomerTree2 = this.loadCustomerTree2.bind(this);
    this.onLoadData = this.onLoadData.bind(this);
    this.loop = this.loop.bind(this);
    this.setSelectedKeys = this.setSelectedKeys.bind(this);
    this.positionCustomerNode = this.positionCustomerNode.bind(this);
    this.positionCustomerNode2 = this.positionCustomerNode2.bind(this);
    this.setTreeShow = this.setTreeShow.bind(this);
    this.setValue = this.setValue.bind(this);
    this.sendAccountId = this.sendAccountId.bind(this);
    this.hideTree = this.hideTree.bind(this);
    this.clearInput = this.clearInput.bind(this);
    this.selectName = this.selectName.bind(this);
    this.deepToRoot = this.deepToRoot.bind(this);
    this.getAllParentAccount = this.getAllParentAccount.bind(this);
    this.setSearchTreeVisible = this.setSearchTreeVisible.bind(this);
    this.changeSimpleUrl = this.changeSimpleUrl.bind(this);
    this.chagneOrganizationId = this.chagneOrganizationId.bind(this);
    this.updateDatas_simple = this.updateDatas_simple.bind(this);
    this.refreshSetId = this.refreshSetId.bind(this);
    this.deepToRoot_GPS = this.deepToRoot_GPS.bind(this);
    this.reLoadSubTree = this.reLoadSubTree.bind(this);
    this.scrollToSelectedNode = this.scrollToSelectedNode.bind(this);
    this.checkIsInTreeWrapper = this.checkIsInTreeWrapper.bind(this);
    window.setSelectedValue = this.setSelectedValue.bind(this);
    this.setSelectedValue = this.setSelectedValue.bind(this);
  }

  componentWillMount() {
      f_loadCustomerTree = this.loadCustomerTree;
    document.body.removeEventListener('click', this.checkIsInTreeWrapper);
  }

  componentDidMount() {
    this.loadCustomerTree(this.props.accountId?this.props.accountId:localStorage.getItem('accountId'));
    let accountId = localStorage.getItem("currentAccountId")?localStorage.getItem("currentAccountId"):localStorage.getItem("accountId");
    let accountName = localStorage.getItem("currentAccountName")?localStorage.getItem("currentAccountName"):localStorage.getItem("accountName");
    if (this.props.selectedKeys || (this.props.treeName == 'main' && accountId)) {
      this.setSelectedKeys(this.props.selectedKeys||accountId);
    }
    if (this.props.ownerName || (this.props.treeName == 'main' &&  accountName)) {
      this.refs.selectInput.setValue(this.props.ownerName || accountName);
    }
    document.body.addEventListener('click', this.checkIsInTreeWrapper);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedKeys !== this.props.selectedKeys) {
      this.setSelectedKeys(nextProps.selectedKeys);
    }
    if (nextProps.ownerName !== this.props.ownerName) {
      this.refs.selectInput.setValue(nextProps.ownerName);
    }
    if (nextProps.searchUrl != this.props.searchUrl) {
      this.setState({
        searchUrl: nextProps.searchUrl
      });
    }
    if (nextProps.accountId != this.props.accountId) {

      this.setState({
        organizationId: nextProps.accountId,
        userData: null,
      },()=>{
        this.loadCustomerTree(nextProps.accountId);
      });
    }
  }
  reLoadSubTree(accountId){
    this.setState({
      organizationId: accountId,
      userData: null,
    },()=>{
      this.loadCustomerTree(accountId);
    });
  }

  setSearchTreeVisible(data) {
    this.setState({
      treeVisible: data
    });
  }


  changeSimpleUrl(url) {
    this.setState({
      searchUrl: url
    });
  }

  chagneOrganizationId(organizationId) {
    this.setState({
      organizationId
    }, () => {
      if (this.props.getOrgId) {
        this.props.getOrgId(organizationId);
      }
    });
  }

  updateDatas_simple(data) {
    this.setState({
      treeVisible: data.treeVisible,
      popVisible: data.popVisible,
      searchUrl: data.searchUrl
    });
  }

  refreshSetId(data) {
    this.setState({
      refresh_f: data.refresh_f,
      organizationId: data.organizationId
    });
  }

  // 展开所有父节点并定位
  getAllParentAccount(organizationId) {
    const url = `/rest/rms/organization/list/parents?organizationId=${organizationId}`;
    const that = this;
    Tools.fetch(url, 'GET', (data) => {
      if (data && data.resultStatusBean) {
        if (data.resultStatusBean.code == 0) {
          if (data.data instanceof Array) {
            const expandedKeys = [];
            data.data.map((item) => {
              expandedKeys.push(String(item.organizationId));
            });
            that.deepToRoot(expandedKeys, organizationId);
          }
        } else if (data.resultBean.code == 40010) {
          message.error(data.resultBean.result);
        }
      }
    });
  }

  deepToRoot(expandedKeys, organizationId,accountName) {

    if (this.state.platform === 'gps') {
      if (this.props.onTreeChange) {
        this.props.onTreeChange(organizationId,accountName);
      }
      this.deepToRoot_GPS(expandedKeys, organizationId, 0);
    }
  }
  scrollToSelectedNode(){
    let that = this;
    setTimeout(() => {
      // 客户节点被选中，执行滚动操作
      const pClass = that.props.treeName;
      const container = $(`#simple_tree_new_${pClass}`).find(".customer_tree");
      const scrollTo = container.find('.ant-tree-treenode-selected.ant-tree-treenode');
      // console.log(scrollTo.offset().top ,container.offset().top,container.scrollTop())
      if (scrollTo.offset()) {
        container.animate({
          scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()-130
        }, 200);
      }
    }, 500);
  }
  // 风控树加载-包含要展开层次的子树节点
  deepToRoot_GPS(treeNodeKeys, organizationId, index) {
    const that = this;
    if (index >= treeNodeKeys.length) {
      setTimeout(() => {
        that.setState({
          selectedKeys: [organizationId.toString()],
          loading: false
        }, () => {
          // 客户节点被选中，执行滚动操作
         /* if(that.props.onTreeChange){
            that.props.onTreeChange(organizationId)
          }*/
          that.scrollToSelectedNode();
        });
      }, 200);
      return false;
    }

    return new Promise((resolve, reject) => {
      let url = '/rest/account/subtree';
      if (treeNodeKeys[index]) {
        url = `${url}?parentId=${treeNodeKeys[index]}`;
      }
      if (that.state.type) {
        url = `${url}&type=${that.state.type}`;
      }
      fetch(Tools.getNoCacheURL(url), {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=utf-8'
        },
        cache: 'no-cache',
        credentials: 'include'
      }).then((response) => {
        if (response.status === 504) {
          message.error('请求超时，请稍后再试');
        } else if (response.status === 401) {
          Tools.toLoginPageForSessionExpired(response);
        } else {
          return response.json();
        }
      }).then((data) => {
        if (data && data.resultBean) {
          if (data.resultBean.code === 0) {
            data = Tools.dataTransferTree(data, localStorage.getItem('platform'));
            const getUserData = (initUserData, data) => {
              if (!initUserData) {
                return data;
              }
              replaceNodeData(initUserData);


              function replaceNodeData(initUserData) {
                if (initUserData.organizationId === data.organizationId) {
                  let hasChild = false;
                  if (initUserData.subOrganizationList instanceof Array) {
                    initUserData.subOrganizationList.map((item) => {
                      if (item.subOrganizationList instanceof Array) {
                        hasChild = true;
                        return false;
                      }
                    });
                  }
                  if (!hasChild) {
                    initUserData.subOrganizationList = data.subOrganizationList;
                  }
                } else if (initUserData instanceof Array) {
                  initUserData.map((item) => {
                    replaceNodeData(item);
                  });
                } else if (initUserData.subOrganizationList instanceof Array) {
                  initUserData.subOrganizationList.map((item) => {
                    replaceNodeData(item);
                  });
                }
              }

              return initUserData;
            };
            that.setState({
              userData: getUserData($.extend(true, {}, that.state.userData), data),
              expandedKeys: [...that.state.expandedKeys, treeNodeKeys[index]],
              autoExpandParent: true,
              organizationId: organizationId.toString()
            }, () => {
              resolve();
            });
          } else {
            message.warning(data.resultBean.result);
          }
        }
      }).catch((error) => {
        that.setState({
          loading: false
        }, () => {
          reject();
        });
      });
    }).then(() => {
      // 递归加载树节点
      that.deepToRoot_GPS(treeNodeKeys, organizationId, ++index);
    });
  }


  // 展开/收起节点时触发
  onExpand(expandedKeys, e) {
    if (e.expanded) {
      this.setState({
        expandedKeys,
        autoExpandParent: false
      });
    } else if (expandedKeys instanceof Array) {
      const _expandedKeys = expandedKeys.filter(item => item != e.node.props.eventKey);
      this.setState({
        expandedKeys: _expandedKeys,
        autoExpandParent: false
      });
    }
  }

  // 定位到指定客户节点并选中
  positionCustomerNode(treeNodeKeys, organizationId) {
    const that = this;
    const _treeNodeKeys = [];
    if (treeNodeKeys instanceof Array) {
      if (treeNodeKeys.length === 0) {
        treeNodeKeys.push(organizationId);
      }
      that.loadCustomerTree2(_treeNodeKeys.concat(treeNodeKeys), 0, organizationId);
    }
  }

  positionCustomerNode2(treeNodeKeys, organizationId) {
    this.positionCustomerNode(treeNodeKeys, organizationId);
  }

  // 异步加载客户节点数据2
  loadCustomerTree2(treeNodeKeys, index, organizationId) {
    this.deepToRoot(treeNodeKeys, organizationId);
  }

  // 异步加载客户节点数据
  loadCustomerTree(treeNodeKey, forceRefresh, treeNodeKeys, index, reflsh) {
    if (!forceRefresh) {
      forceRefresh = false;
    }
    const that = this;

    // 存儲節點的key值
    if (treeNodeKey) {
      window.treeNodeKey = treeNodeKey;
    }
    const { organizationId, status ,type} = this.state;
    let url = Tools.getApiUrl('treeUrl',this.props.platform);
    if (treeNodeKeys instanceof Array) {
      if (index == treeNodeKeys.length) {
        return;
      }
      treeNodeKey = treeNodeKeys[index];
    }
    if (treeNodeKey) {
      url = `${url}?parentId=${treeNodeKey}`;
    } else if (organizationId) {
      url = `${url}?parentId=${organizationId}`;
    }
    if (status !== undefined) {
      url = `${url}&status=${status}`;
    }
    if (type) {
      url = `${url}&type=${type}`;
    }
    that.setState({
      loading: true
    });
    fetch(Tools.getNoCacheURL(url), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      },
      cache: 'no-cache',
      credentials: 'include'
    }).then((response) => {
      that.setState({
        loading: false
      });
      if (response.status == 504) {
        // message.error("请求超时，请稍后再试");
      } else if (response.status == 401) {
        // toLoginPageForSessionExpired(response);
      } else {
        return response.json();
      }
    }).then((data) => {
      // 将风控接口的数据进行转换
      data = Tools.dataTransferTree(data, localStorage.getItem('platform'));
      if (data.resultBean) {
        if (data.resultBean.code == 0) {
          const getUserData = (initUserData, data) => {
            if (!initUserData) {
              return data;
            }
            replaceNodeData(initUserData);


            function replaceNodeData(initUserData) {
              if (initUserData.organizationId === data.organizationId) {
                let hasChild = false;
                if (initUserData.subOrganizationList instanceof Array) {
                  initUserData.subOrganizationList.map((item) => {
                    if (item.subOrganizationList instanceof Array) {
                      hasChild = true;
                      return false;
                    }
                  });
                }
                if (forceRefresh) {
                  initUserData.subOrganizationList = data.subOrganizationList;
                } else if (!hasChild) {
                  initUserData.subOrganizationList = data.subOrganizationList;
                }
              } else if (initUserData instanceof Array) {
                initUserData.map((item) => {
                  replaceNodeData(item);
                });
              } else if (initUserData.subOrganizationList instanceof Array) {
                initUserData.subOrganizationList.map((item) => {
                  replaceNodeData(item);
                });
              }
            }

            return initUserData;
          };
          const userData = getUserData(that.state.userData, data);
          that.setState({
            userData,
            autoExpandParent: true
          }, () => {
            if (that.state.showRootName) {
              that.refs.selectInput.setValue(that.state.userData.name);
              if (that.props.handleChange) {
                that.props.handleChange(that.state.userData.organizationId, that.state.userData.name);
              }
            }
          });

          // 递归加载树节点
          if (treeNodeKeys instanceof Array) {
            that.loadCustomerTree(null, null, treeNodeKeys, ++index);
          }
        } else {
          message.warning(data.resultBean.result);
        }
      }
    }).catch((error) => {
      that.setState({
        loading: false
      });
    });
  }

  setSelectedKeys(key, nodeName) {
    this.setState({
      selectedKeys: [key],
      organizationId: key
    }, () => {
      if (this.props.handleChange) {
        if (nodeName) {
          this.props.handleChange(key, nodeName);
        }
      }
    });
  }

  // 选择客户树节点
  onSelect(info, e) {
    const organizationId = info[0];
    const nodeName = e.node.props.nodeName;
    const nodeKey = e.node.props.eventKey;
    const storageAccountId = localStorage.getItem('organizationId');
    const { expandedKeys } = this.state;
    window.treeTitle = nodeName;
    this.refs.selectInput.setValue(nodeName);
    window.init_flag = true;
    if (organizationId) {
      this.setSelectedKeys(organizationId, nodeName);
      // 选择节点同时展开节点
      expandedKeys.push(organizationId);
      expandedKeys.push(storageAccountId);
      this.setState({
        expandedKeys,
        autoExpandParent: false,
        showRootName: false
      }, () => {
        if (!e.node.props.isLeaf) {
          this.loadCustomerTree(organizationId);
        }
      });
    } else if (e.node.props.expanded) {
      if (e.node.props.eventKey !== storageAccountId) {
        const _expandedKeys = expandedKeys.filter(item => item !== e.node.props.eventKey);
        _expandedKeys.push(storageAccountId);
        this.setState({
          expandedKeys: _expandedKeys,
          autoExpandParent: false,
          showRootName: false
        });
      }
    } else {
      expandedKeys.push(e.node.props.eventKey);
      this.setState({
        expandedKeys,
        autoExpandParent: false,
        showRootName: false
      });
    }
    if (this.props.onTreeChange && organizationId) {
      this.props.onTreeChange(organizationId,nodeName);
    }
    this.refs.selectInput.setState({
      selectShow: 'none',
      optionData:[]
    })
    this.hideTree();
  }

  // 异步加载树节点
  onLoadData(treeNode) {
    const that = this;
    return new Promise((resolve) => {
      that.loadCustomerTree(treeNode.props.eventKey);
      resolve();
    });
  }


  getNodeTitle(nodeData) {
    const {type} = this.state;
    let userName;
    if (nodeData.accountStatsBean) {
      userName = nodeData.name + " (" + nodeData.accountStatsBean.deviceNo + "/" + nodeData.accountStatsBean.deviceTotalNo + ")";
    } else {
      userName = nodeData.name;
    }
    if(type == 1) {
      userName = nodeData.name
    }
    return userName;
  }

  loop(userData) {
    const orgNode = () => {
      return <i className="iconfont icon-mendian"></i>
    };
    const leafNode = () =>{
      return <i className="iconfont icon-kehu"></i>
    }
    const mapper = (item) => {
      if (item.subOrganizationList instanceof Array) {
        return this.loop(item);
      }
      return (
        <TreeNode nodeName={item.name} title={this.getNodeTitle(item)} key={item.organizationId} isLeaf={item.isLeaf == 0} icon={item.isLeaf == 0?leafNode:orgNode}/>
      );
    };
    if (userData) {
      if (userData instanceof Array) {
        return userData.map(mapper);
      } if (userData.subOrganizationList instanceof Array) {
        return (
          <TreeNode nodeName={userData.name} title={this.getNodeTitle(userData)} key={userData.organizationId} isLeaf={userData.isLeaf == 0} icon={userData.isLeaf == 0?leafNode:orgNode}>
            {userData.subOrganizationList.map(mapper)}
          </TreeNode>);
      }
      return (
        <TreeNode
          nodeName={userData.name}
          title={this.getNodeTitle(userData)}
          key={userData.organizationId}
          isLeaf={userData.isLeaf == 0}
          icon={userData.isLeaf == 0?leafNode:orgNode}
        />
      );
    }
    return null;
  }

  selectName(organizationId, value) {
    this.setState({accountName:value},()=>{
      if (this.props.selectName instanceof Function) {
        this.props.selectName(organizationId, value);
      }
    })

  }
  checkIsInTreeWrapper(e){
    if (!this.props.disHide && this.props.treeName) {
      const x = e.pageX;
      const y = e.pageY;
      const pClass = this.props.treeName;

      const div = $(`#simple_tree_new_${pClass}`).eq(0);// 获取你想要的DIV
      const searchDiv = $(`#search_input_${pClass}`).eq(0);// 搜索框
      if (div.offset() && searchDiv.offset()) {
        const y1 = div.offset().top; // div上面两个的点的y值
        const y2 = y1 + div.height();// div下面两个点的y值
        const x1 = div.offset().left; // div左边两个的点的x值
        const x2 = x1 + div.width(); // div右边两个点的x的值

        const y3 = searchDiv.offset().top; // div上面两个的点的y值
        const y4 = y3 + searchDiv.height();// div下面两个点的y值
        const x3 = searchDiv.offset().left; // div左边两个的点的x值
        const x4 = x3 + searchDiv.width(); // div右边两个点的x的值
        // console.log(x>=x1 && x<=x2 &&  y>=y1 && y<=y2)
        // console.log(x>=x3 && x<=x4 && y>=y3 && y<=y4)
        if ((x >= x1 && x <= x2 && y >= y1 && y <= y2) || (x >= x3 && x <= x4 && y >= y3 && y <= y4)) {
          // console.log('鼠标在该DIV中');
        } else {
          // console.log('鼠标在该DIV外');
          this.setTreeShow(false);
        }
      }
    }
  }

  // 是否显示客户树
  setTreeShow(data) {
    this.setState({
      showTree:data
    })
    if(data){
      this.scrollToSelectedNode();
    }
    if (this.props.disabled) {
      return;
    }
  }


  setValue(data) {
    this.refs.selectInput.setValue(data);
  }

  setSelectedValue(accountId,accountName) {
    console.log(accountId,accountName)
    this.setState({
      selectedKeys: [accountId.toString()],
      organizationId: accountId
    });
    this.refs.selectInput.setValue(accountName);
    this.refs.selectInput.getAllParentAccount(accountId);
    if (this.props.handleChange) {
      this.props.handleChange(accountId, accountName);
    }
  }

  // 当匹配到第一个项的时候传id
  sendAccountId(id, accountValue) {
    if (this.props.sendAccountId) {
      this.props.sendAccountId(id, accountValue);
    }
    if (this.props.handleChange) {
      this.props.handleChange(id, accountValue);
    }
  }

  hideTree() {
    this.setState({
      showTree: false
    });
  }

  clearInput() {
    this.refs.selectInput.setState({
      value: ''
    });
  }


  render() {
    const {
      treeVisible, popVisible, searchUrl, showSearchInput,
      userData, expandedKeys, defaultSelectedKeys, width, autoExpandParent, selectedKeys,
      disabled, widths, heights ,type,showTree,accountName
    } = this.state;
    let that = this;
    return (
      <div  className={"tree_wrapper"} id={"tree_wrapper_"+this.props.treeName} >
          <MyAutoComplete
            width={width}
            type={type}
            {...this.props}
            onSelect={this.onSelect}
            positionCustomerNode={(expandedKeys, organizationId,accountName) => { this.deepToRoot(expandedKeys, organizationId,accountName); }}
            showTree={this.setTreeShow}
            setTreeShow={this.setTreeShow}
            sendAccountId={this.sendAccountId}
            searchUrl={searchUrl}
            disabled={disabled}
            selectName={this.selectName}
            ref="selectInput"
            accountName={accountName}
          >
          </MyAutoComplete>
          <div className={"simple_tree_new"} id={"simple_tree_new_"+this.props.treeName} style={{display:showTree?"":"none"}}
                >
            <Tree
                showIcon
              loadData={this.onLoadData}
              onSelect={this.onSelect}
              onExpand={this.onExpand}
              expandedKeys={expandedKeys}
              selectedKeys={selectedKeys}
              autoExpandParent={autoExpandParent}
              defaultSelectedKeys={defaultSelectedKeys}
              className="customer_tree"
                getPopupContainer={()=>document.getElementById("simple_tree_new_"+this.props.treeName)}
            >
              {this.loop(userData)}
            </Tree>
          </div>
      </div>
    );
  }
}
